// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
import { StyleSheet } from "react-native";
import fonts from "../../config/fonts";
const TransportCardStyle = StyleSheet.create({
  container: {
    borderRadius: 8,
    marginBottom: 5,
    elevation: 2,
    marginTop: 7,
  },
  routeContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  plannedDateContainer: {
    marginTop: 10,
    alignItems: "center",
  },
  plannedDateText: {
    fontSize: 18,
    color: "white",
    textAlign: "center",
  },
  firstCont: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
  },
  secondCont: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
  },
  textContainer: {
    flexGrow: 1,
    alignItems: "flex-start",
    flexWrap: "wrap",
  },

  arrowContainer: {
    alignItems: "center",
  },
  expandedContainer: {
    paddingBottom: 32,
  },
  details: {
    marginTop: 16,
  },
  expandedDetails: {
    minHeight: 190,
  },
  horizontalDivider: {
    height: 1,
    backgroundColor: "#780073",
    marginVertical: 8,
  },
  inputCont: {
    backgroundColor: "#c4007a",
    borderRadius: 8,
    textAlign: "center",
    paddingVertical: 10,
  },
  input: {
    backgroundColor: "#c4007a",
    height: 48,
    borderRadius: 8,
    paddingHorizontal: 16,
    color: "white",
    textAlign: "center",
    width:"30%",
    marginLeft:"35%",
    marginBottom:5
  },
  text: {
    fontSize: 13,
    textAlign: "center",
    color: "#780073",
    paddingVertical: 2,
    fontFamily: fonts.regular,
  },
  textBold: {
    fontSize: 16,
    textAlign: "center",
    color: "#780073",
    fontWeight: "bold",
    fontFamily: fonts.regular,
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 16,
    fontFamily: fonts.regular,
  },
  icon: {
    marginLeft: 8,
  },
  title: {
    fontSize: 15,
    textAlign: "center",
    fontWeight: "bold",
    fontFamily: fonts.regular,
  },
  plusIcon: {
    position: "absolute",
    top: 8,
    right: 8,
  },
  button: {
    backgroundColor: "purple",
    height: 30,
    borderRadius: 8,
    alignItems: "center",
    justifyContent: "center",
  },
  buttonText: {
    color: "white",
    fontSize: 16,
    fontWeight: "bold",
    textAlign: "center",
    paddingVertical: 14,
    fontFamily: fonts.regular,
  },
  image: {
    width: 96,
    height: 51,
  },
  warningText: {
    color: "red",
    marginTop: 5,
    fontSize: 16,
    textAlign: "center",
    fontFamily: fonts.regular,
  },
});

export default TransportCardStyle;
